import {
	AfterContentInit,
	Component,
	Input,
	OnDestroy,
	Optional
} from "@angular/core";
import { LoadingOverlayService } from "./services/loading-overlay.service";
import { Subject, takeUntil } from "rxjs";

@Component({
	selector: "app-loading-overlay",
	templateUrl: "./loading-overlay.component.html",
	styleUrls: ["./loading-overlay.component.scss"],
	standalone: false
})
export class LoadingOverlayComponent implements AfterContentInit, OnDestroy {
	@Input() key: string | undefined = undefined;
	@Input() show = false;
	@Input() showOnlyBg = false;
	@Input() showFade = false;
	@Input() showSpinner = true;
	@Input() title = "Aguarde";
	@Input() subtitle = "Estamos validando algumas informações";
	@Input() image = "/assets/images/base-logo.svg";
	@Input() timeToHideLoading = 5000;

	private _onDestroy = new Subject<boolean>();

	constructor(
		@Optional()
		private readonly loadingOverlayService: LoadingOverlayService
	) {}

	ngAfterContentInit(): void {
		this.watchForNewLoadingOverlay();
	}

	watchForNewLoadingOverlay(): void {
		if (this.loadingOverlayService) {
			this.loadingOverlayService.loadingOverlay$
				.pipe(takeUntil(this._onDestroy))
				.subscribe((loadingOverlay) => {
					if (loadingOverlay) {
						if (this.key && loadingOverlay.key === this.key) {
							this.show = loadingOverlay.show ?? this.show;
							this.showOnlyBg =
								loadingOverlay.showOnlyBg ?? this.showOnlyBg;
							this.showFade =
								loadingOverlay.showFade ?? this.showFade;
							this.showSpinner =
								loadingOverlay.showSpinner ?? this.showSpinner;
							this.title = loadingOverlay.title ?? this.title;
							this.subtitle =
								loadingOverlay?.subtitle ?? this.subtitle;
							this.image = loadingOverlay.image ?? this.image;
							return;
						}
					}
				});
		}
	}

	ngOnDestroy(): void {
		this._onDestroy.next(true);
	}
}
